interface SalaryCardProps {
  className?: string;
}

export function SalaryCard({ className = '' }: SalaryCardProps) {
  return (
    <div
      className={`bg-white w-full max-w-[400px] p-10 rounded-3xl shadow-2xl -rotate-1 border border-white ${className}`}
    >
      <div className="w-12 h-12 bg-soft-paper rounded-xl flex items-center justify-center mb-6 text-2xl">
        💸
      </div>

      <div className="font-mono text-xs uppercase tracking-widest text-gray-500 mb-4">
        Payroll Preview • Q4
      </div>

      <div className="flex justify-between mb-4 text-[0.95rem]">
        <span className="text-gray-500">Gross Salary</span>
        <span className="font-semibold text-deep-ink">$5,500.00</span>
      </div>

      <div className="flex justify-between mb-4 text-[0.95rem]">
        <span className="text-gray-500">Take Home Pay</span>
        <span className="font-semibold text-indigo-600">$4,825.50</span>
      </div>

      <div className="mt-6 bg-cyan-100 text-cyan-800 px-4 py-2 rounded-full flex items-center gap-2 font-semibold text-sm">
        🛡️ NIB Contribution Matched
      </div>

      <div className="mt-8 border-t border-gray-100 pt-6 text-center">
        <span className="font-mono text-[0.7rem] uppercase tracking-widest text-gray-500">
          Status: Ready for Deposit
        </span>
      </div>
    </div>
  );
}
